export const updatePos = (pos, target) => {
  let { x, y } = pos;
  const { top, left, right, bottom } = target.getBoundingClientRect();
  const { clientWidth, clientHeight } = document.documentElement;

  const elHidesUp = top < 0;
  const elHidesLeft = left < 0;
  const elHidesDown = bottom > clientHeight;
  const elHidesRight = right > clientWidth;

  const changeTop = (y) => y - top;
  const changeBottom = (y) => y - (bottom - clientHeight);
  const changeLeft = (x) => x - left;
  const changeRight = (x) => x - (right - clientWidth);

  if (elHidesUp) {
    y = changeTop(y);
  }

  if (elHidesDown) {
    y = changeBottom(y);
  }

  if (elHidesLeft) {
    x = changeLeft(x);
  }

  if (elHidesRight) {
    x = changeRight(x);
  }

  return { x, y };
};
